import { Injectable } from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationEnd } from '@angular/router'
import { LocalStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root',
})

export class NavigationService {

  public history: string[] = [];

  constructor(
    private router: Router,
    private location: Location,
    private storage: LocalStorageService) {
    
  }

  public startSaveHistory():void {

    this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {
        var rootUrl = sessionStorage.getItem('rootUrl');   
    
        var gameProviderId = sessionStorage.getItem('gameProviderId'); 
        var gameProviderSuccess = sessionStorage.getItem('gameProviderSuccess');
        
        // console.log("event.urlAfterRedirects", event.urlAfterRedirects);
        console.log("rootUrl in navigation service", rootUrl);
        //bet-confirm to bet-confirm //added rootUrl != auto-login
        if ((event.urlAfterRedirects == "/threed/bet-confirm" || event.urlAfterRedirects == "/twod/bet-confirm") && (rootUrl != null && rootUrl != 'auto-login') ) {
          
          if (rootUrl == "package") {
            this.router.navigate(["/twod/bet"],{replaceUrl: true});
            this.goBack();   
            this.goBack(); 
            this.goBack();    
            this.goBack();                   
            sessionStorage.clear();
            sessionStorage.setItem("localShowAds",'false');
            return;
          } else {
            this.router.navigate([rootUrl],{replaceUrl: true});
            this.goBack();   
            this.goBack(); 
            this.goBack();   
            sessionStorage.clear();
            sessionStorage.setItem("localShowAds",'false');
            return;
          }
        } 
        // forget noti
        // if (event.urlAfterRedirects == "/home" && rootUrl == "forget-noti") {  
        //   this.router.navigate(['/auth/welcome'],{ replaceUrl: false }); 
        //   return;
        // }
        // if (event.urlAfterRedirects == '/auth/welcome' && rootUrl == "forget-noti") { 
        //   this.router.navigate(['/auth/login'],{ replaceUrl: false });             
        //   return;      
        // }
        // if (event.urlAfterRedirects == '/auth/login' && rootUrl == "forget-noti") {
        //   sessionStorage.clear();
        //   sessionStorage.setItem("localShowAds",'false');
        //   this.router.navigate(['/auth/forget-password'],{ replaceUrl: false }); 
        //   return;      
        // }
        if (event.urlAfterRedirects == '/home' && rootUrl == "forget-noti") {
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          this.router.navigate(['/auth/forget-password'],{ replaceUrl: true }); 
          return;      
        }
        
        // forget password waiting link       
        if (event.urlAfterRedirects == '/auth/forget-password' && rootUrl == "waiting-one") {
          this.goBack();  
          this.goBack();  
          return;        
        }
        if (event.urlAfterRedirects == '/auth/welcome' && rootUrl == "waiting-one") {
          this.goBack();                                                                
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }

        if (event.urlAfterRedirects == '/auth/forget-password' && rootUrl == "waiting-two") {
          this.goBack();  
          this.goBack();  
          this.goBack();                                                        
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }
        if (event.urlAfterRedirects == "/home" && rootUrl == "waiting-two") {
          this.goBack(); 
          this.goBack(); 
          this.goBack();                          
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }       

        // forget password link 
        if (event.urlAfterRedirects == '/auth/forget-password' && rootUrl == "service-phone") { 
          this.goBack();  
          this.goBack(); 
          this.goBack();         
          return;
        }
        if ((event.urlAfterRedirects == "/home" || event.urlAfterRedirects == "/profile/me") && rootUrl == "service-phone") {
          this.router.navigate(["/service-phone"],{replaceUrl: true});                                                     
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }

        // click service phone
        if (event.urlAfterRedirects == '/auth/forget-password' && rootUrl == "click-service-phone") { 
          this.goBack();  
          this.goBack();
          return;
        }
        if (event.urlAfterRedirects == "/home" && rootUrl == "click-service-phone") {
          this.router.navigate(["/service-phone"],{replaceUrl: true});                                                     
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }        
        
        // forget not firsttopup
        if (event.urlAfterRedirects == '/auth/forget-password' && rootUrl == "home") {             
          this.goBack();  
          this.goBack();          
          return; 
        } 
        if (event.urlAfterRedirects == '/auth/welcome' && rootUrl == "home") {             
          this.goBack();                   
          sessionStorage.clear();  
          sessionStorage.setItem("localShowAds",'false');      
          return; 
        } 

        if (event.urlAfterRedirects == "/game/wallet" && gameProviderId == "ProviderId" && gameProviderSuccess == "success") {             
          this.goBack();
          this.goBack();                   
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return; 
        } 
        if (event.urlAfterRedirects == "/game/wallet" && gameProviderSuccess == "success") {  
          this.goBack();                        
          sessionStorage.clear();  
          sessionStorage.setItem("localShowAds",'false');      
          return; 
        } 
        
        if ((event.urlAfterRedirects == '/auth/welcome' && rootUrl == "auto-login")||
         (event.urlAfterRedirects == '/auth/login' && rootUrl == "auto-login") ) {    
          this.goBack();
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return; 
        }
        if (event.urlAfterRedirects == "/profile/me" && rootUrl == "auto-login") {
          //this.router.navigate(['/home'], { replaceUrl: true });// comment because redirect to home if click on profile sometimes, 20250611
          sessionStorage.clear();      
          sessionStorage.setItem("localShowAds",'false');
          return; 
        }
        // register autologin
        if (event.urlAfterRedirects == "/home" && rootUrl == "register-auto-login") {
          //this.goBack(); // register, commnet because of redirect to auth_otp page, 20250524
          //this.goBack(); // welcome, commnet because of redirect to auth_otp page, 20250524
          sessionStorage.clear();      
          return;
        }
        if (event.urlAfterRedirects == "/auth/welcome" && rootUrl == "register-auto-login") {
          this.goBack(); // home
          sessionStorage.clear();      
          sessionStorage.setItem("localShowAds", 'false');
          return;
        }
        if (event.urlAfterRedirects == "/profile/me" && rootUrl == "register-auto-login") {
          sessionStorage.clear();      
          sessionStorage.setItem("localShowAds", 'false');
          return;
        }

        // forget password autologin
        if (event.urlAfterRedirects == "/home" && rootUrl == "forget-password-auto-login") {
          this.storage.clear("localForgetLoginDevice");
          this.goBack(); // forget-password-check-success
          this.goBack(); // forget-password
          this.goBack(); // login
          return;
        } //tEMP
        if (event.urlAfterRedirects == "/home" && rootUrl == "forget-password-new-device-auto-login") {
          this.storage.clear("localForgetLoginDevice");
          this.goBack(); // reset-password
          this.goBack(); // forget-password-check-success
          this.goBack(); // forget-password
          this.goBack(); // login
          return;
        }
        if (
          (event.urlAfterRedirects == '/auth/login' && rootUrl == "forget-password-auto-login") ||
          (event.urlAfterRedirects == '/auth/login' && rootUrl == "forget-password-new-device-auto-login")
        ) {
          this.goBack(); // welcome or me-page
          return;
        }
        if (
          (event.urlAfterRedirects == '/auth/welcome' && rootUrl == "forget-password-auto-login") ||
          (event.urlAfterRedirects == '/auth/welcome' && rootUrl == "forget-password-new-device-auto-login")
        ) {
          this.goBack(); // home or me-page
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }
        if (
          (event.urlAfterRedirects == "/profile/me" && rootUrl == "forget-password-auto-login") ||
          (event.urlAfterRedirects == "/profile/me" && rootUrl == "forget-password-new-device-auto-login")
        ) {
          sessionStorage.clear();
          sessionStorage.setItem("localShowAds",'false');
          return;
        }
        if (rootUrl == null || rootUrl == "null") {
          this.history.push(event.urlAfterRedirects);         
        }

      }

    });

  }

  public getHistory(): string[] {
    return this.history;
  }
 
  public getPreviousUrl(): string {
    if (this.history.length > 0) {
      return this.history[this.history.length - 2];
    }
    return '';
  }

  public goBack(): void {
    this.history.pop();
    if (this.history.length > 0) {
      this.location.back();
    } else {
      this.router.navigateByUrl("/");
    }
  }
}